<template>
  <v-card class="mx-auto">
    <v-system-bar   height="50">
      <v-btn
        outlined
        small
        fab
        dark
        class="transparent"
        @click.stop="$router.go(-1)"
      >
        <v-icon>mdi-arrow-left-circle</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      Test divers
      <v-spacer></v-spacer>

      <v-btn
        outlined
        small
        fab
        dark
        class="transparent"
        @click.stop="$router.go(-1)"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-system-bar>
    <!--   <v-btn @click="importOnce">Traiter fiches4</v-btn> -->
    <v-container>
      {{ elems }}
      <v-list>
        <v-list-item
          v-for="(item, index) in collections"
          :key="index"
          class="project"
        >
          <v-list-item-content>
            <v-list-item-title>Collection:</v-list-item-title>
            <v-list-item-subtitle v-html="item"></v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-icon>
            <v-btn icon @click="detailsCollection(item)">
              <v-icon>chevron_right</v-icon>
            </v-btn>
          </v-list-item-icon>
        </v-list-item>
      </v-list>
    </v-container>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      elems: [],
    };
  },
  mounted() {
    this.getbyid();
  },
  methods: {
    getbyid() {
      var docRef = this.$firebase
        .firestore()
        .collection("etapes_effectives")
        .doc("fff82e87bdba09c1dc64a6132538259b018478e1");
      let self = this;
      docRef
        .get()
        .then(function (doc) {
          if (doc.exists) {
            console.log("Document data:", doc.data());
            self.elems.push({
              ...doc.data(),
              id: doc.id,
            });
          } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
          }
        })
        .catch(function (error) {
          console.log("Error getting document:", error);
        });
    },
    importOnce() {
      console.log("manomboka ny fiches4");
      /*  var self = this;
      let jsonFilePath = require("../../../traitements/t_fiches/vita/t_fiches4.json");
      Object.keys(jsonFilePath).forEach(function (item) {
        var elem = item;
        self.$firebase
          .firestore()
          .collection("fiches")
          .doc(item)
          .set(jsonFilePath[item]);
      }); */
      console.log("vita ny fiches4");
    },
    ...mapActions({
      getListeCollections: "Collection/getListeCollections",
    }),
  },
  computed: {
    ...mapState({
      collections: (state) => state.Collection.collections,
    }),
  },
};
</script>

<style></style>
